import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { firestore, functions } from "firebase/app";
import moment from "moment";
const fb = require("./firebaseConfig.js");

Vue.use(Vuex);
fb.auth.useDeviceLanguage();
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit("setCurrentUser", user);
    store.dispatch("fetchUserData");
    store.dispatch("fetchUserToken");
    //store.dispatch('fetchUserImage')
  }
});

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userData: {},
    userToken: null,
    userImage: require("@/assets/user_profile.png"),
    languages: [
      { code: "es", name: "Español" },
      { code: "en", name: "English" }
    ],
    actionCodeSettings: {
      url: "https://mybodytone.eu/",
      handleCodeInApp: true
    }
  },
  actions: {
    clearData({ commit }) {
      commit("setCurrentUser", null);
      commit("setUserData", {});
    },
    fetchUserToken({ commit, state }) {
      fb.auth.currentUser
        .getIdToken(/* forceRefresh */ true)
        .then(idToken => {
          commit("setUserToken", idToken);
        })
        .catch(function(error) {
          // Handle error
        });
    },
    fetchUserData({ commit, state }) {
      return new Promise((resolve, reject) => {
        fb.usersCollection
          .where("email", "==", state.currentUser.email)
          .get()
          .then(res => {
            let user = null;
            res.forEach(doc => {
              user = doc.data();
              user.id = doc.id;
            });
            commit("setUserData", user);
            resolve(user);
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },
    fetchSpinningData({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        let limit = 100;
        let baseQuery = fb.sessionsCollection;
        //baseQuery = baseQuery.where('user', '==', 'IcXCfsjb5LeGLHpfgi6ELpOSYPL2');
        baseQuery = baseQuery.where("user", "==", state.currentUser.uid);
        if(params && params.activity!=='all'){
          var activity = params && params.activity ? params.activity : "indoorcycling";
          baseQuery = baseQuery.where('activity', '==', activity);
        }
       
       
        if (params && params.orderBy) {
          for (let orderByObj of params.orderBy) {
            if (params.paginateDirection == "backward") {
              // reverse the query from the configured orderBy (trick to query backward)
              baseQuery = baseQuery.orderBy(
                "closedAt",
                orderByObj.directionStr == "desc" ? "asc" : "desc"
              ); // reverse the ordering
            } else {
              baseQuery = baseQuery.orderBy(
                "closedAt",
                orderByObj.directionStr == "desc" ? "desc" : "asc"
              );
            }
          }
        }
        if (params && params.range) {
          const _range = parseInt(params.range);
          var from = moment()
            .subtract(_range, "days")
            .unix();
          var to = moment().unix();
          baseQuery = baseQuery.startAt(from).endAt(to);
        }

        if (params && typeof params.limit == "number" && params.limit > 0) {
          limit = params.limit;
        }

        baseQuery = baseQuery.limit(limit);
        //fb.sessionsCollection.where('user', '==', 'kcpA7A7JqMYdSt9CmPBIOlUFyEh1').where('activity', '==','indoorcycling').limit(15).orderBy('insertAt', 'desc').get().then(res => {
    
        baseQuery
          .get()
          .then(res => {
            let sessions = [];
            res.forEach(doc => {
              let _session = doc.data();
              _session.id = doc.id;
              sessions.push(_session);
            });
            resolve(sessions);
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },

    saveProfile({ commit, state }, payload) {
      return fb.auth.currentUser.getIdToken(true).then(idToken => {
        const authString = "Bearer ".concat(idToken);
        let config = {
          headers: {
            Authorization: authString
          }
        };

        return new Promise((resolve, reject) => {
          axios
            .post(
              "https://us-central1-bodytone-app.cloudfunctions.net/saveprofile",
              payload.form,
              config
            )
            .then(response => {
              resolve(response);
            })
            .catch(err => {
              reject(err);
            });
        });
      });
    },

    exportSession({ commit, state }, payload) {
      return fb.auth.currentUser.getIdToken(true).then(idToken => {
        const authString = "Bearer ".concat(idToken);
        let config = {
          headers: {
            Authorization: authString
          },
          responseType: "blob"
        };

        return new Promise((resolve, reject) => {
          axios
            .post(
              "https://us-central1-bodytone-app.cloudfunctions.net/exportSession",
              { sessionId: payload.sessionId },
              config
            )
            .then(response => {
              resolve(response);
            })
            .catch(err => {
              reject(err);
            });
        });
      });
    },
    fetchUserImage({ commit, state }) {
      return new Promise((resolve, reject) => {
        fb.storage
          .child(state.currentUser.uid)
          .getDownloadURL()
          .then(url => {
            resolve(url);
          })
          .catch(err => {
            reject(err);
          });
      }).catch(err => {
        reject(err);
      });
    },

    savestravatokens({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        var savestravatokens = fb.fn.httpsCallable("savestravatokens");

        return savestravatokens(payload.stravaauth)
          .then(response => {
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    savetrainingymtokens({ commit, state }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        var savetrainingymtokens = fb.fn.httpsCallable("savetrainingymtokens");

        return savetrainingymtokens(payload.trainingymauth)
          .then(response => {
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    deletestravatokens({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        var deletestravatokens = fb.fn.httpsCallable("deletestravatokens");

        return deletestravatokens()
          .then(response => {
            console.log(response);
            resolve(response);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteTrainingymTokens({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        var deleteTrainingymTokens = fb.fn.httpsCallable("deleteTrainingymTokens");

        return deleteTrainingymTokens()
          .then(response => {
            console.log(response);
            resolve(response);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    getUserStravaInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        fb.stravaCollection
          .doc(state.currentUser.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              resolve(true);
            }

            resolve(false);
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },
    getUserTrainingymInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        fb.trainingymCollection
          .doc(state.currentUser.uid)
          .get()
          .then(doc => {
            if (doc.exists) {
              resolve(true);
            }

            resolve(false);
          })
          .catch(err => {
            reject(err);
            console.log(err);
          });
      });
    },
    updatePassword(pass) {
      var user = fb.auth().currentUser;
      return user.updatePassword(pass);
    },

    reauthenticate({ commit, state }, data) {
      var user = fb.auth.currentUser;
      const credential = fb.credentials.credential(user.email, data.pass);
      return user.reauthenticateWithCredential(credential);
    },

    fetchUserImage({ commit, state }) {
      return new Promise((resolve, reject) => {
        fb.storage
          .child(state.currentUser.uid)
          .getDownloadURL()
          .then(url => {
            resolve(url);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    updateProfile({ commit, state }, data) {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .update(data)
        .then(user => {
          console.log("user profile updated");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val;
    },
    setUserData(state, val) {
      state.userData = val;
    },
    setUserImage(state, val) {
      state.userImage = val;
    },
    setUserToken(state, val) {
      state.userToken = val;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store.js